<template>
  <MyJump v-if="jump" :to="jump" :msg="$t('page.login.login_ok')"/>
  <div v-else class="page-login">
    <div class="title">{{$t('page.login.title')}}</div>
    <Form ref="formLogin" :model="formInfo" :rules="ruleValidate" :label-width="120">
      <FormItem :label="$t('page.login.state_code')" prop="state_code">
        <SCodeSelect v-model="formInfo.state_code" prepared
                     :placeholder="$t('page.login.ph_statecode')"/>
      </FormItem>
      <FormItem :label="$t('page.login.mobile')" prop="mobile">
        <Input v-model="formInfo.mobile" maxlength="20" ref="mobile"
               prefix="ios-phone-portrait"
               :placeholder="$t('page.login.ph_mobile')"/>
      </FormItem>
      <FormItem :label="$t('page.reg.pwd')" prop="password">
        <Input v-model="formInfo.password" maxlength="15" ref="pwd"
               :type="type?'password':'text'"
               prefix="ios-key"
               :placeholder="$t('page.reg.ph_pwd')">
          <Icon  :type="type?'ios-eye':'ios-eye-off'" class="btn-eye" slot="suffix" @click="onShowPwd()" size="20"/>
        </Input>
      </FormItem>
    </Form>
    <div style="width: 100%;text-align: right">
        <a @click.stop="toForgot">{{$t('page.login.forgot')}}</a>
    </div>

    <div>
      <div :style="{height:footerButtonHeight+'px'}"></div>
      <div ref="bottomButtons" class="bottom-buttons bottom-buttons-fixed">
        <Button @click="login" type="error"
                :loading="logining"
                class="btn btn-ok"
                style="margin-bottom: 10px;">{{$t('page.login.btn_login')}}</Button>
        <Button @click="toRegister" type="default"
                class="btn"
                style="margin-bottom: 10px;">{{$t('page.login.btn_reg')}}</Button>
      </div>
    </div>
  </div>
</template>
<script>
    import SCodeSelect from '@/components/SCodeSelect';
    import MyJump from '@/components/MyJump';
    import common from '@/mixins/common';

    export default {
        components: {
            MyJump,
            SCodeSelect
        },
        mixins: [common],
        data () {
            const validatePass = (rule, value, callback) => {
                if (value === '') {
                    return callback(new Error(this.$t('page.login.ph_pwd')))
                } else if (!/^\w{6,15}$/.test(value)) {
                    return callback(new Error(this.$t('page.reg.ph_pwd')))
                }
                callback()
            }
            return {
                jump: null,

                from: null,
                logining: false,
                retry_cnt: 0,
                last_time: 0,

                autoLogin: 0,
                type: true,
                formInfo: {
                    state_code: '',
                    mobile: '',
                    password: ''
                },
                ruleValidate: {
                    state_code: [
                        { required: true, message: this.$t('page.login.ph_statecode'), trigger: 'change' }
                    ],
                    mobile: [
                        { required: true, message: this.$t('page.login.ph_mobile'), trigger: 'change' }
                    ],
                    password: [
                        { required: true, trigger: 'blur', validator: validatePass }
                    ]
                }
            }
        },
        methods: {
            onShowPwd (type) {
                this.type = !this.type
            },
            login () {
                if (this.logining) {
                    return;
                }
                // 频繁点击
                const now = new Date().getTime();
                if (this.last_time + 1000 > now) {
                    this.$Message.error(this.$t('page.login.quick_opt'));
                    return;
                }
                this.last_time = now;

                this.$refs.formLogin.validate((valid) => {
                    if (valid) {
                        this.$store.commit('setLocalInfo', {
                            account: this.mobile,
                            code: this.state_code
                        });

                        this.logining = true;
                        this.$Spin.show();
                        this.$store.dispatch('login', {
                            stateCode: this.formInfo.state_code,
                            mobile: this.formInfo.mobile,
                            password: this.formInfo.password
                        }).then(() => {
                            // 跳转
                            this.jump = this.$route.params.target;
                        }).catch((error) => {
                            this.$Modal.error({
                                title: this.$t('page.login.login_fail'),
                                content: error.message + ' <br/><br/>' + this.$t('common.err_server')
                            });
                        }).finally(() => {
                            this.$Spin.hide();
                            this.logining = false;
                        });
                    }
                });
            },
            getTarget () {
                let route = this.$route.params.target;
                if (!route) {
                    route = this.$route.params.from;
                }
                if (route) {
                    route = this.$router.match(route);
                }
                if (!route) {
                    route = '/';
                }
                return route;
            },
            toRegister () {
                this.$router.face.login(true);
            },
            toForgot () {
                this.$router.push({
                    name: 'ResetPwd',
                    params: {
                        target: this.getTarget()
                    }
                });
            }
        },
        created () {
            const info = this.$store.state.local_info;
            if (info) {
                this.formInfo.state_code = info.code;
                this.formInfo.mobile = info.account;
            }
        },
        mounted () {
            // 监测回车
            document.onkeydown = e => {
                if (e.key === 'Enter') {
                    if (e.target === document.body || e.target.type === 'password') {
                        this.login();
                    }
                }
            };
            if (this.mobile) {
                this.$refs.pwd.focus();
            }
        }
    };
</script>

<style lang="scss">
  .page-login {
      padding: 1vw;
      width: 100%;
      max-width: 600px;
      text-align: center;
      margin: auto;

      .btn-eye{
        cursor: pointer;
        &:hover{
          opacity: 0.5;
        }
      }
  }
</style>
